import { Component, Input } from "@angular/core";
import { UserRoleType } from "@apiserver-rest/ponder-auth-client-base";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { environment } from "../../../../environments/environment";

@Component({
    selector: "profile-role-badge",
    imports: [SvgIconComponent],
    templateUrl: "./profile-role-badge.component.html"
})
export class ProfileRoleBadgeComponent {
    @Input({ required: true }) public userRole!: UserRoleType;
    
    public roleColor: string = environment.colors.roles.user;
    public roleLabel: string = "User";
    
    public readonly starSvgIcon = SvgIcon.Star;

    public constructor() {

    }

    public ngOnInit(): void {
        switch (this.userRole) {
            case UserRoleType.UserPlus:
                this.roleLabel = "User Plus";
                this.roleColor = environment.colors.roles.userPlus;
                break;

            case UserRoleType.Moderator:
                this.roleLabel = "Moderator";
                this.roleColor = environment.colors.roles.moderator;
                break;

            case UserRoleType.Administrator:
                this.roleLabel = "Administrator";
                this.roleColor = environment.colors.roles.administrator;
                break;

            default:
                this.roleLabel = "User";
                this.roleColor = environment.colors.roles.user;
                break;
        }
    }

    public hasElevatedRole(): boolean {
        return (this.userRole != UserRoleType.User) && (this.userRole != UserRoleType.None);
    }
}